import { useTranslation } from 'react-i18next';
import { Badge } from '@components/ui/badge';
import type { BookingStatus } from '@api/types';

interface BookingStatusBadgeProps {
  status: BookingStatus;
}

const statusVariantMap: Record<BookingStatus, 'default' | 'secondary' | 'destructive' | 'success' | 'warning'> = {
  pending: 'warning',
  confirmed: 'success',
  checked_in: 'success',
  cancelled: 'destructive',
  rescheduled: 'secondary',
  completed: 'default',
  noshow: 'secondary',
  pending_clinic_approval: 'warning',
  rejected: 'destructive',
};

export function BookingStatusBadge({ status }: BookingStatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge variant={statusVariantMap[status]} data-testid="booking-status-badge">
      {t(`booking.status.${status}`)}
    </Badge>
  );
}
